<template>
  <Input v-model="local" @input="emitUpdate" />
</template>

<script>
import { Input } from "@/shared/ui/input";

export default {
  components: { Input },
  props: ["item"],
  data() {
    return { local: this.item.value ?? "" };
  },
  methods: {
    emitUpdate() {
      this.$emit("update", this.item.key, this.local ? this.local : null);
    },
  },
};
</script>
